import type { TargetProduct } from '@post-office/message-templates-common--puma/in-app/cjn-nav4/types';
import {
	LoomCcpId,
	type ValidProductCcpId,
} from '@post-office/message-template-contracts/message-template-metadata';

export const targetProduct: { productId: ValidProductCcpId; productKey: TargetProduct } = {
	productId: LoomCcpId,
	productKey: 'loom',
};
